<section class="residences" id="residences">

  <!-- Header -->
  <div class="residences-shell">
    <div class="residences-header reveal">
      <p class="section-label">The Residences</p>
      <h2 class="residences-title">The<br>Interiors</h2>
      <p class="residences-copy">
         Within these walls, elegance meets intimacy. The interiors evoke
        the spirit of a highland retreat, layered textures, natural light,
        and a palette drawn from earth and sky. Every suite is designed
        as a refuge in the clouds, where craftsmanship, comfort, and
        quiet sophistication converge.
      </p>
    </div>
  </div>

  <!-- ── 1 BEDROOM ── -->
  <div class="res-bed-label reveal">1 Bedroom</div>

  <div class="res-view-tabs reveal">
    <button class="res-view-tab" [class.active]="activeView1 === 'renders'"   (click)="activeView1 = 'renders'">Renders</button>
    <button class="res-view-tab" [class.active]="activeView1 === 'floorplan'" (click)="activeView1 = 'floorplan'">Floor Plan</button>
  </div>

  <div class="res-slider-wrap" [class.hidden]="activeView1 !== 'renders'">
    <swiper-container
      #swiperEl1
      class="res-slider reveal reveal-delay-1"
      slides-per-view="1"
      space-between="0"
      centered-slides="true"
      rewind="true"
      grab-cursor="true"
      speed="900"
      [pagination]="pagination"
      [autoplay]="autoplay"
      [breakpoints]="breakpoints"
    >
      @for (slide of slides1; track slide.src) {
        <swiper-slide>
          <article class="res-card">
            <div class="res-media">
              <button type="button" class="res-media-hit" (click)="openAt1($index, $event)" aria-label="View fullscreen"></button>
              <button type="button" class="res-expand-btn" (click)="openAt1($index, $event)" aria-label="Expand image">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M7 17L17 7M17 7H10M17 7v7"/>
                  <path d="M7 17H14M7 17v-7"/>
                </svg>
              </button>
              <img [src]="slide.src" alt="1 Bedroom interior at Acacia" class="res-image" loading="lazy" />
            </div>
            <div class="res-meta">
              <div class="res-step"><span class="res-step-line"></span></div>
              <div class="res-text">
                <h3>1 Bedroom</h3>
                <p>{{ slide.label }}</p>
              </div>
            </div>
          </article>
        </swiper-slide>
      }
    </swiper-container>
    <div class="res-nav">
      <button class="res-nav-btn res-nav-prev" (click)="prevSlide1()" aria-label="Previous slide">
        <div class="res-nav-ring"></div>
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M11 14L6 9l5-5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </button>
      <button class="res-nav-btn res-nav-next" (click)="nextSlide1()" aria-label="Next slide">
        <div class="res-nav-ring"></div>
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M7 4l5 5-5 5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </button>
    </div>
  </div>

  <div class="res-floorplan" [class.hidden]="activeView1 !== 'floorplan'">
    <div class="res-fp-subtabs">
      @for (v of fp1Variants; track v.id) {
        <button class="res-fp-subtab" [class.active]="activeFp1 === v.id" (click)="activeFp1 = v.id">{{ v.label }}</button>
      }
    </div>
    @for (v of fp1Variants; track v.id) {
      @if (activeFp1 === v.id) {
        <div class="res-fp-info">
          <p class="res-fp-bed">1 Bedroom</p>
          <p class="res-fp-type">{{ v.label }}</p>
          <p class="res-fp-size">{{ v.size }}</p>
        </div>
        <img [src]="v.image" [alt]="'1 Bedroom ' + v.label + ' floor plan'" class="res-floorplan-img" />
      }
    }
  </div>

  <!-- ── Divider ── -->
  <div class="res-divider">
    <div class="res-divider-line"></div>
    <div class="res-divider-emblem">
      <img src="/backgrounds/twig.webp" alt="" aria-hidden="true" />
    </div>
    <div class="res-divider-line"></div>
  </div>

  <!-- ── 2 BEDROOM ── -->
  <div class="res-bed-label reveal">2 Bedroom</div>

  <div class="res-view-tabs reveal">
    <button class="res-view-tab" [class.active]="activeView2 === 'renders'"   (click)="activeView2 = 'renders'">Renders</button>
    <button class="res-view-tab" [class.active]="activeView2 === 'floorplan'" (click)="activeView2 = 'floorplan'">Floor Plan</button>
  </div>

  <div class="res-slider-wrap" [class.hidden]="activeView2 !== 'renders'">
    <swiper-container
      #swiperEl2
      class="res-slider reveal reveal-delay-1"
      slides-per-view="1"
      space-between="0"
      centered-slides="true"
      rewind="true"
      grab-cursor="true"
      speed="900"
      [pagination]="pagination"
      [autoplay]="autoplay"
      [breakpoints]="breakpoints"
    >
      @for (slide of slides2; track slide.src) {
        <swiper-slide>
          <article class="res-card">
            <div class="res-media">
              <button type="button" class="res-media-hit" (click)="openAt2($index, $event)" aria-label="View fullscreen"></button>
              <button type="button" class="res-expand-btn" (click)="openAt2($index, $event)" aria-label="Expand image">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M7 17L17 7M17 7H10M17 7v7"/>
                  <path d="M7 17H14M7 17v-7"/>
                </svg>
              </button>
              <img [src]="slide.src" alt="2 Bedroom interior at Acacia" class="res-image" loading="lazy" />
            </div>
            <div class="res-meta">
              <div class="res-step"><span class="res-step-line"></span></div>
              <div class="res-text">
                <h3>2 Bedroom</h3>
                <p>{{ slide.label }}</p>
              </div>
            </div>
          </article>
        </swiper-slide>
      }
    </swiper-container>
    <div class="res-nav">
      <button class="res-nav-btn res-nav-prev" (click)="prevSlide2()" aria-label="Previous slide">
        <div class="res-nav-ring"></div>
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M11 14L6 9l5-5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </button>
      <button class="res-nav-btn res-nav-next" (click)="nextSlide2()" aria-label="Next slide">
        <div class="res-nav-ring"></div>
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M7 4l5 5-5 5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </button>
    </div>
  </div>

  <div class="res-floorplan" [class.hidden]="activeView2 !== 'floorplan'">
    <div class="res-fp-subtabs">
      @for (v of fp2Variants; track v.id) {
        <button class="res-fp-subtab" [class.active]="activeFp2 === v.id" (click)="activeFp2 = v.id">{{ v.label }}</button>
      }
    </div>
    @for (v of fp2Variants; track v.id) {
      @if (activeFp2 === v.id) {
        <div class="res-fp-info">
          <p class="res-fp-bed">2 Bedroom</p>
          <p class="res-fp-type">{{ v.label }}</p>
          <p class="res-fp-size">{{ v.size }}</p>
        </div>
        <img [src]="v.image" [alt]="'2 Bedroom ' + v.label + ' floor plan'" class="res-floorplan-img" />
      }
    }
  </div>

</section>

<div #lgContainer1 style="display:none"></div>
<div #lgContainer2 style="display:none"></div>
